export default function PlayIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <rect width="20" height="20" rx="10" fill="currentColor" />
      <path
        d="M12.6071 10.5602C12.4881 11.0526 11.9256 11.4006 10.8006 12.0966C9.71302 12.7693 9.16931 13.1057 8.73106 12.9705C8.54988 12.9146 8.38481 12.8084 8.25169 12.6621C7.92969 12.3084 7.92969 11.6222 7.92969 10.25C7.92969 8.87775 7.92969 8.19157 8.25169 7.83782C8.38481 7.69156 8.54988 7.58539 8.73106 7.52949C9.16931 7.39427 9.71302 7.73066 10.8006 8.40341C11.9256 9.0994 12.4881 9.44739 12.6071 9.9398C12.6562 10.1431 12.6562 10.3569 12.6071 10.5602Z"
        fill="white"
        stroke="white"
        strokeWidth="1.57143"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const displayName = "PlayIcon";
